/**
 * Rewrites an `https://`/`http://` calendar feed URL to `webcal://` so tapping
 * it opens the OS's native "Subscribe to calendar" flow on iOS and macOS
 * instead of downloading the `.ics` file as a one-time import.
 *
 * @param {string} url
 * @returns {string} `''` for a falsy input.
 */
export function toWebcalUrl(url) {
	if (!url) return '';
	return url.replace(/^https?:\/\//i, 'webcal://');
}
